import React, { type ReactNode } from 'react'

import { LabelWithTooltip } from 'components/_base'
import SimpleTable from 'components/table/SimpleTable'

export type ApiLimitRow = { name: string; description?: string; value: ReactNode }

const config = [
  {
    title: 'Type',
    style: { width: '250px' },
    render: ({ name, description }: ApiLimitRow) =>
      description ? <LabelWithTooltip label={name} tooltip={description} /> : name,
  },
  {
    title: 'Value',
    render: ({ value }: ApiLimitRow) => value,
  },
]

const ApiLimitsTable = ({ rows }: { rows: ApiLimitRow[] }) => <SimpleTable config={config} data={rows} />

export default ApiLimitsTable
